export type ServiceRequestType = "Add Provider" | "I need help finding staff";

export const SERVICE_REQUEST_TYPES: ServiceRequestType[] = [
  "Add Provider",
  "I need help finding staff",
];

export const CLIENT_SERVICES = ["Analyst", "Assistant", "Assessment"];

export const LANGUAGES = [
  "English",
  "Afrikaans",
  "Albanian",
  "Amharic",
  "Arabic",
  "Armenian",
  "Basque",
  "Bengali",
  "Bulgarian",
  "Catalan",
  "Cambodian",
  "Chinese (Mandarin)",
  "Croatian",
  "Czech",
  "Danish",
  "Dutch",
  "Estonian",
  "Fiji",
  "Finnish",
  "French",
  "Georgian",
  "German",
  "Greek",
  "Gujarati",
  "Hebrew",
  "Hindi",
  "Hungarian",
  "Icelandic",
  "Indonesian",
  "Irish",
  "Italian",
  "Japanese",
  "Javanese",
  "Korean",
  "Latin",
  "Latvian",
  "Lithuanian",
  "Macedonian",
  "Malay",
  "Malayalam",
  "Maltese",
  "Maori",
  "Marathi",
  "Mongolian",
  "Nepali",
  "Norwegian",
  "Persian",
  "Polish",
  "Portuguese",
  "Punjabi",
  "Quechua",
  "Romanian",
  "Russian",
  "Samoan",
  "Serbian",
  "Slovak",
  "Slovenian",
  "Spanish",
  "Swahili",
  "Swedish",
  "Tamil",
  "Tatar",
  "Telugu",
  "Thai",
  "Tibetan",
  "Tonga",
  "Turkish",
  "Ukrainian",
  "Urdu",
  "Vietnamese",
  "Welsh",
  "Xhosa",
];

export interface ClientOption {
  id: number;
  name: string;
  /** Encrypted client id accepted by the client availability endpoints. */
  encryptedId: string | null;
}

/**
 * One day/time range of a client's weekly schedule as entered on the form.
 * `day` follows JS `Date.getDay()` (0 = Sunday … 6 = Saturday);
 * `start`/`end` are "HH:mm" (24h). `end` may be "24:00" for midnight.
 */
export interface ClientScheduleSlot {
  id: string;
  day: number;
  start: string;
  end: string;
}

export interface Weekday {
  day: number;
  label: string;
  short: string;
}

/** Monday-first display order; `day` keeps the JS getDay() index. */
export const WEEKDAYS: Weekday[] = [
  { day: 1, label: "Monday", short: "Mon" },
  { day: 2, label: "Tuesday", short: "Tue" },
  { day: 3, label: "Wednesday", short: "Wed" },
  { day: 4, label: "Thursday", short: "Thu" },
  { day: 5, label: "Friday", short: "Fri" },
  { day: 6, label: "Saturday", short: "Sat" },
  { day: 0, label: "Sunday", short: "Sun" },
];
